import { Button, Icon, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Card, AppLoader } from '@hero/atoms';
import { useRecogRecipientsBulkUpsert } from '@hero/services';
import { clearObject } from '@hero/utils';

import { UPLOAD_SPREADSHEET_STEP } from './constants';
import * as S from './style';

function ReviewImport({ setFooterProps, setStep, uploadedRecipients, onRequestClose }) {
  const { t } = useTranslation();
  const { recognitionCode } = useParams();
  const { mutateAsync: recipientBulkUpsert, isLoading: isRecipientBulkUpsertLoading } =
    useRecogRecipientsBulkUpsert();

  useEffect(() => {
    setFooterProps({
      leftButtonText: t('back'),
      leftButtonOnClick: () => {
        setStep(UPLOAD_SPREADSHEET_STEP);
      },
      isLeftButtonActive: true,
      isRightButtonActive: true,
      rightButtonOnClick: async () => {
        if (
          uploadedRecipients.length > 0 &&
          uploadedRecipients.filter(r => r.hasError).length === 0
        ) {
          await recipientBulkUpsert({
            params: {
              code: recognitionCode
            },
            body: {
              recipients: uploadedRecipients.map(contact =>
                clearObject({
                  email: contact.email,
                  firstName: contact?.firstName
                })
              )
            }
          });

          onRequestClose();
        }
      },
      rightButtonText: t('import'),
      activeStepIndex: 2
    });
  }, [uploadedRecipients]);

  return (
    <>
      {isRecipientBulkUpsertLoading && <AppLoader />}
      <S.ReviewHead>
        <S.ReviewHeadTitle>
          <Typography variant="body1Bold">{t('reviewAndImport')}</Typography>
          <Typography variant="body2" color="fg" emphasis="weaker">
            {t('reviewAndImportRecipientDescription')}
          </Typography>
        </S.ReviewHeadTitle>
        <Button
          variant="link"
          color="fg"
          onClick={() => {
            setStep(UPLOAD_SPREADSHEET_STEP);
          }}
        >
          {t('startOver')}
        </Button>
      </S.ReviewHead>
      <Card>
        <S.ResultItem>
          <S.ResultTitle variant="body2">{t('recipients')}:</S.ResultTitle>
          <S.ResultBody>
            <S.ResultDescription>
              <Trans
                i18nKey="recipientsReadyToBeImported"
                values={{ amount: uploadedRecipients.length }}
                components={{ b: <b /> }}
              />
            </S.ResultDescription>
            <Button
              variant="link"
              color="neutral"
              onClick={() => {
                setStep(UPLOAD_SPREADSHEET_STEP);
              }}
              startIcon={<Icon name="edit" />}
            >
              {t('edit')}
            </Button>
          </S.ResultBody>
        </S.ResultItem>
      </Card>

      <S.InfoText>{t('dragAndDropFileInfo')}</S.InfoText>
    </>
  );
}

ReviewImport.propTypes = {
  setFooterProps: PropTypes.func,
  setStep: PropTypes.func,
  uploadedRecipients: PropTypes.func,
  onUpdatingDone: PropTypes.func,
  onRequestClose: PropTypes.func
};

export { ReviewImport };
